// 充值订单列表
export default {
    heard_title: "项目订单列表",
    fl_search: "输入搜索:",
    fp_search: "手机号码/商品名称/订单编号",
    fl_submitTime: "提交时间:",
    fp_startTime: "请选择开始日期",
    fp_endTime: "请选择结束日期",
    btn_recharge: "充值",
    // 表格
    tl_no: "订单编号",
    tl_orderTime: "提交时间",
    tl_mobile: "手机号码",
    tl_amount: "订单金额",
    tl_rewardAmount: "赠送金额",
    tl_balance: "余额",
    tl_paymentModel: "支付方式",
    tl_channel: "订单来源",
    btn_print: "打印小票",

    // 提示
    sm_print: "打印成功",
    rm_print: "打印失败",

    remove_resHint: "删除",
    sm_resHint: "成功",
    rm_resHint: "失败"
};
